import { Button, Flex, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import React from "react";
import useSWR from "swr";
import ListRow from "./ListRow";

export default function OrderDetailCompanyInfoModal({ companyId }) {
  const [opened, { open, close }] = useDisclosure(false);

  const { data } = useSWR(opened ? [`/companies/${companyId}`] : null);

  const company = data?.data?.attributes || {};

  return (
    <>
      <Button fullWidth onClick={open}>
        화주 정보
      </Button>

      <Modal opened={opened} onClose={close} title="화주 정보" zIndex={10000}>
        <ListRow label="출근 시간" val={company.loadTimeMemo || "-"} />
        <ListRow label="점심 시간" val={company.lunchTimeMemo || "-"} />
        <ListRow label="퇴근 시간" val={company.endTimeMemo || "-"} />
        <ListRow label="메모" val={company.memo || "-"} />
        <ListRow label="사무실 번호" val={company.officeNumber || "-"} />
        <ListRow label="팩스 번호" val={company.faxNumber || "-"} isLast />
        <Flex justify="flex-end" mt="md">
          <Button variant="default" onClick={close}>
            닫기
          </Button>
        </Flex>
      </Modal>
    </>
  );
}
